import { finalize } from "rxjs";
import { SubscriptionsService } from "../../settings/account/subscriptions/subscriptions.service";
import { Subscription } from "../../settings/account/subscriptions/subscriptions.types";
import { ModalContentTypes } from "../constants/modal-content-types";
import { ModalContentService } from "../modal-content/modal-content.service";
import { unableOperationMessage } from "./utils";
import { OrderService } from "../order.service";
import { Router } from "@angular/router";

export const openModalSkipProduct = (
    data: {
        sub: Subscription,
        modalContentService: ModalContentService,
        subscriptionsService: SubscriptionsService,
        orderService: OrderService,
        router: Router,
        goToCustomizeBundle?: boolean
    }) => {

    const { sub, modalContentService, subscriptionsService, orderService, router, goToCustomizeBundle } = data;

    if (!sub) return unableOperationMessage(modalContentService);

    modalContentService.openModal(ModalContentTypes.CONFIRMATION, {
        title: `Skip '${sub.product.name}' for This Delivery?`,
        textContent: `You’ve chosen to <b>SKIP</b> <b><i>${sub.product.name}</i></b> for your delivery on <b><i>${sub.shownNextDelivery}</i></b>. Your next scheduled delivery for this product will be on <b><i>${sub.shownNextDeliveryAfterSkip}</i></b>.`,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Ok',
    }).closed
        .subscribe((res: { confirm: boolean } | null) => {
            if (res?.confirm) skipProduct({ subscription: sub, subscriptionsService, orderService, router, goToCustomizeBundle });
        })
}

const skipProduct = (
    data: {
        subscription: Subscription,
        subscriptionsService: SubscriptionsService,
        orderService: OrderService,
        router: Router,
        goToCustomizeBundle?: boolean
    }) => {
    const { subscription, subscriptionsService, orderService, router, goToCustomizeBundle } = data;
    subscriptionsService.update(subscription.id, { skip: true }, true).pipe(
        finalize(() => {
            orderService.getOrder();
            if (goToCustomizeBundle)
                router.navigate([`/shop/custom-box/subscription/${subscription.product.id}`]);
        })
    ).subscribe()
}

export const openModalUnskipProduct = (
    data: {
        sub: Subscription,
        modalContentService: ModalContentService,
        subscriptionsService: SubscriptionsService,
        orderService: OrderService,
        router: Router,
        goToCustomizeBundle?: boolean
    }) => {

    const { sub, modalContentService, subscriptionsService, orderService, router, goToCustomizeBundle } = data;

    if (!sub) return unableOperationMessage(modalContentService);

    modalContentService.openModal(ModalContentTypes.CONFIRMATION, {
        title: `Add '${sub.product.name}' Back to Your Delivery?`,
        textContent: `You’ve chosen to <b>UNSKIP</b> <b><i>${sub.product.name}</i></b> for your delivery on <b><i>${sub.skipDate}</i></b>.`,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Ok',
    }).closed
        .subscribe((res: { confirm: boolean } | null) => {
            if (res?.confirm) unskipProduct({ subscription: sub, subscriptionsService, orderService, router, goToCustomizeBundle });
        })
}

const unskipProduct = (data: {
    subscription: Subscription,
    subscriptionsService: SubscriptionsService,
    orderService: OrderService,
    router: Router,
    goToCustomizeBundle?: boolean
}) => {
    const { subscription, subscriptionsService, orderService, router, goToCustomizeBundle } = data;
    subscriptionsService.update(subscription.id, { unskip: true }, true).pipe(
        finalize(() => {
            orderService.getOrder();
            if (goToCustomizeBundle)
                router.navigate([`/shop/custom-box/subscription/${subscription.product.id}`]);
        })
    ).subscribe()
}


export const getProductSubscriptioninfo = (subscriptions: Subscription[], productId: number) => {
    if (!subscriptions?.length) return null;
    const sub = subscriptions.find(s => s?.product?.id === productId);
    if (!sub) return null;
    return sub
}